import { useNavigate, useParams, useSearchParams } from "react-router";
import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useTestLabels } from "@/hooks/useTestLabels";
import { useMasks } from "@/hooks/useMasks";

import { LoadingDisplay } from "@/components/shared/LoadingDisplay";
import { GenericErrorDisplay } from "@/components/shared/ErrorDisplay";
import { Main } from "@/components/shared/Main";
import { Header } from "@/components/shared/Header";
import { EditTestLabelForm } from "./components/EditTestLabelForm";

function EditTestLabelView() {
  const { testLabelId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const {
    data: testLabels,
    isLoading: isTestLabelsLoading,
    error: isTestLabelsError,
  } = useTestLabels();

  const { data: masks, isLoading: isMasksLoading, error: isMasksError } = useMasks();

  // Get mask query parameter
  const maskQueryParam = searchParams.get("mask");

  if (isTestLabelsLoading || isMasksLoading) {
    return <LoadingDisplay />;
  }

  if (isTestLabelsError || isMasksError) {
    return <GenericErrorDisplay />;
  }

  const testLabel = testLabels.find((r) => r.id === Number(testLabelId));

  if (!testLabel) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex items-center gap-4">
            <Button variant="ghost" onClick={() => navigate(-1)}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
            <h1 className="text-3xl font-bold">Test Label not found</h1>
          </div>
          <p className="mt-4">The requested Test Label could not be found.</p>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />
      <Main>
        <EditTestLabelForm testLabel={testLabel} masks={masks} maskQueryParam={maskQueryParam} />
      </Main>
    </>
  );
}

export default EditTestLabelView;
